import { FormlyFieldConfig } from '@ngx-formly/core';
import { TripettoNode, TripettoI18Model } from '../utils/tripetto-interfaces';

/**
 * Convert Tripetto languages block to Formly static field with default language
 * Warning about i18n limitation is added in processCluster() method
 */
export function convertLanguagesBlock(node: TripettoNode, formlyType: string): FormlyFieldConfig {
	// Extract default language text from i18Models
	const i18Models: TripettoI18Model[] = node?.i18Models || [];

	// Find the first available language (prefer 'en' if available)
	const availableLanguages = [...new Set(i18Models.map((m) => m.langCode))];
	const defaultLang = availableLanguages.includes('en') ? 'en' : availableLanguages[0] || 'en';

	// Extract name and description for the default language
	const nameModel = i18Models.find((m) => m.slot === 'name' && m.langCode === defaultLang);
	const descriptionModel = i18Models.find((m) => m.slot === 'description' && m.langCode === defaultLang);

	// Even display-only fields need a unique key for Formly/Angular Forms
	// Use node.id as the key since languages blocks are display-only
	const key = node.id || `languages_${Date.now()}_${Math.random()}`;

	// Warning will be added in processCluster() method
	return {
		key,
		type: formlyType,
		props: {
			name: nameModel?.text || node.name,
			description: descriptionModel?.text || node.description
		}
	};
}
